<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">{{ menuItem.name }}</div>
		<div class="ms-auto">
			<app-record-control-footer
				(onCancelChange)="onMenuItemCanvasClearEmitter.emit(true)"
				(onSaveChange)="onMenuItemSave()"
				[saveDisabled]="!unsavedChanges"
				[hideDelete]="true"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<div *ngIf="menuItem">
		<p-tabView *ngIf="venueSvc.ooVenue?.venueKey">
			<p-tabPanel headerStyleClass="p-tab-header">
				<ng-template pTemplate="header">
					<fa-icon [icon]="['far', 'info-circle']" size="lg" class="ms-1"></fa-icon>
					Details
				</ng-template>
				<app-menu-item-detail [menuItemKey]="menuItem.menuItemKey" (unsavedChangesChange)="unsavedChanges = $event"></app-menu-item-detail>
			</p-tabPanel>
			<p-tabPanel headerStyleClass="p-tab-header">
				<ng-template pTemplate="header">
					<fa-icon [icon]="['far', 'dollar-sign']" size="lg" class="ms-1"></fa-icon>
					<div class="mx-2">Prices</div>
				</ng-template>
				<app-menu-item-price-record *ngIf="loadComplete" [menuItem]="menuItem" [priceLevel]="priceLevel"> </app-menu-item-price-record>
			</p-tabPanel>
			<p-tabPanel headerStyleClass="p-tab-header">
				<ng-template pTemplate="header">
					<fa-icon [icon]="['far', 'palette']" size="lg" class="ms-1"></fa-icon>
					<div class="mx-2">Canvases</div>
				</ng-template>
				<app-menu-item-canvas-view
					*ngIf="loadComplete"
					[canvasList]="venueSvc.ooCanvases"
					[menuItem]="menuItem"
					[ooMenuItemCanvases]="menuItemCanvases"
					[ooCanvasMenuItems]="ooCanvasMenuItems"
					[venueKey]="venueSvc.venueKey"
				>
				</app-menu-item-canvas-view>
			</p-tabPanel>
			<p-tabPanel headerStyleClass="p-tab-header">
				<ng-template pTemplate="header">
					<fa-icon [icon]="['far', 'cheese']" size="lg" class="ms-1"></fa-icon>
					<div class="mx-2">Modifiers</div>
				</ng-template>
				<app-menu-item-modifier-view
					*ngIf="loadComplete"
					[canvasList]="venueSvc.ooCanvases"
					[menuItem]="menuItem"
					[ooMenuItemCanvases]="menuItemCanvases"
					[venueKey]="venueSvc.venueKey"
				></app-menu-item-modifier-view>
			</p-tabPanel>
			<p-tabPanel headerStyleClass="p-tab-header">
				<ng-template pTemplate="header">
					<fa-icon [icon]="['far', 'apple-whole']" size="lg" class="ms-1"></fa-icon>
					<div class="mx-2">Nutritional Info</div>
				</ng-template>
				<app-menu-item-nutritional-information
					[menuItemKey]="menuItem.menuItemKey"
					(changesToSave)="unsavedChanges = $event"
				></app-menu-item-nutritional-information>
			</p-tabPanel>
			<p-tabPanel headerStyleClass="p-tab-header">
				<ng-template pTemplate="header">
					<fa-icon [icon]="['far', 'hand-holding-box']" size="lg" class="ms-1"></fa-icon>
					<div class="mx-2">Subscription Settings</div>
				</ng-template>
				<app-menu-item-subscription-setup
					[menuItemKey]="menuItem.menuItemKey"
					(unsavedChangesChange)="unsavedChanges = $event"
				></app-menu-item-subscription-setup>
			</p-tabPanel>
		</p-tabView>
	</div>
</div>
